import type { FaceTraits, GenerateResponse } from "./types";

export async function generateFaceFromSelfie(
  imageBase64: string,
  mimeType: string,
  cachedTraits?: FaceTraits | null,
): Promise<GenerateResponse> {
  // Same selfie spun again → send only the cached traits so the server skips
  // the vision analysis and the image upload.
  const payload = cachedTraits
    ? { traits: cachedTraits }
    : { imageBase64, mimeType };

  const response = await fetch("/api/generate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let data: unknown;
  try {
    data = await response.json();
  } catch {
    return {
      ok: false,
      error: `서버 응답을 파싱할 수 없습니다 (${response.status})`,
    };
  }

  if (
    typeof data === "object" &&
    data !== null &&
    "ok" in data &&
    typeof (data as { ok: unknown }).ok === "boolean"
  ) {
    return data as GenerateResponse;
  }

  return {
    ok: false,
    error: `예상치 못한 응답 형식입니다 (${response.status})`,
  };
}
